<template>
  <div class="bossbox">
    <div class="schedule">
      <img :src="userInfo.head_img" alt="" style="width:74px;height:76px;border-radius: 50px;" v-if="userInfo.head_img">
      <img style="width:70px" src="../../../static/img2/tx.png" v-else alt="">
      <div class="pandect">
        <span class="spa1">成绩总览</span>
        <span class="spa2">Results overview</span>
        <img class="spa3" src="../../../static/img2/zonglan1.png" alt="">
        <span class="spa4">有效训练： {{ sum }} 次</span>
        <span class="spa5">有效训练时长：{{ formatSeconds(allTime) }}</span>
        <span class="spa6">班级排名：{{ sum1 }}</span>
        <span class="spa7">年级排名：{{ sum2 }}</span>
        <span class="spa8">最高分：{{ sum3 }}</span>
      </div>
      <div class="statistics">
        <div style="width:200px;margin-top: 5px;">
          <p>
            <span class="progress_out">
              <span class="progress_in" :style="{ width: chartData11 + '%' }"><img :style="{ left: 90.12 + '%' }"
                  src="../../../static/img2/youxi.png"></span>
            </span>
          </p>
          <p>
            <span class="progress_out1">
              <span class="progress_in1" :style="{ width: chartData22 + '%' }"><img :style="{ left: 90.12 + '%' }"
                  src="../../../static/img2/dabiao.png"></span>
            </span>
          </p>
          <p>
            <span class="progress_out2">
              <span class="progress_in2" :style="{ width: chartData33 + '%' }"><img :style="{ left: 90.12 + '%' }"
                  src="../../../static/img2/budabaio.png"></span>
            </span>
          </p>
        </div>
        <div class="percent">
          <p>{{ chartData11 }}%</p>
          <p>{{ chartData22 }}%</p>
          <p>{{ chartData33 }}%</p>
        </div>
        <div class="number_of">
          <p><img class="p1" src="../../../static/img2/uouxidia.png" alt=""><span class="number1">优秀
              （{{ chartData1 }}次）</span></p>
          <p><img class="p2" src="../../../static/img2/dabaidian.png" alt=""><span class="number2">达标
              （{{ chartData2 }}次）</span></p>
          <p><img class="p3" src="../../../static/img2/budadan.png" alt=""><span class="number3">不达标
              （{{ chartData3 }}次）</span></p>
        </div>
      </div>
    </div>
    <div class="options">
      <div class="type">
        <div class="direction1"><span>训练方向：</span><span @click="ofHidden" :class="completeclor(1)"
            style="cursor:pointer;">全部</span></div>
        <div class="directionitem1" v-for="(item, index) in cateTree" :key="index"><span style="cursor:pointer;"
            :class="color(index)" @click="onChangeHandle(item, index)">{{ item.label }} ({{ item.count }})</span></div>
      </div>
      <div class="typebox">
        <div class="direction2"><span>训练类型：</span><span @click="complete" :class="completeclor1(3)"
            style="cursor:pointer;">全部</span></div>
        <div class="directionitem2">
          <span v-for="(item, index) in categoryTwoList" :key="index" @click="training_type(item, index)"
            :class="color2(index)" style="cursor:pointer;">{{ item.label }} ({{ item.count }})</span>
        </div>
        <div class="typebox-bor"></div>
      </div>
    </div>
    <div class="tablelist">
      <el-table ref="filterTable" :data="tableData" style="width: 100%;max-height: 435px;margin-top: 45px;  "
        :row-class-name="tableRowClassName" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(25, 26, 31, 0.8)">
        <el-table-column prop="created_at" label="训练日期" width="280px" sortable align="center" column-key="date">

        </el-table-column>
        <el-table-column label="训练项目">
          <template slot-scope="scope">
            {{ scope.row.learn.name }}
          </template>
        </el-table-column>
        <el-table-column prop="subhead" label="得分模块" width="140" align="center">
          <template slot-scope="scope">
            {{ scope.row.subhead != '' ? scope.row.subhead : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_score" label="得分" width="50px" align="center">
          <template slot-scope="scope">
            {{ scope.row.total_score >= 0 ? scope.row.total_score : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_time" label="用时" :formatter="formatter" width="150px" align="center">
        </el-table-column>
        <el-table-column label="操作" width="150px" align="center">
          <template slot-scope="scope">
            <a size="mini" style="color:#1fb2e5;cursor:pointer;" @click="handleEdit(scope.$index, scope.row)"
              v-if="scope.row.total_score >= 0">查看
            </a>
            <a size="mini" style="color:#C0C4CC;cursor:pointer;" v-else>查看
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <div class="tablelistt">
      <el-table ref="filterTable" :data="tableData" style="width: 100%;margin-top: 45px;  "
        :row-class-name="tableRowClassName" v-loading="loading" element-loading-text="拼命加载中"
        element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">
        <el-table-column prop="created_at" label="训练日期" width="280px" align="center" column-key="date">

        </el-table-column>
        <el-table-column label="训练项目">
          <template slot-scope="scope">
            {{ scope.row.learn.name }}
          </template>
        </el-table-column>
        <el-table-column prop="subhead" label="得分模块" width="140" align="center">
          <template slot-scope="scope">
            {{ scope.row.subhead != '' ? scope.row.subhead : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_score" label="得分" width="50px" align="center">
          <template slot-scope="scope">
            {{ scope.row.total_score >= 0 ? scope.row.total_score : '--' }}
          </template>
        </el-table-column>
        <el-table-column prop="total_time" label="用时" :formatter="formatter" width="150px" align="center">
        </el-table-column>
        <el-table-column label="操作" width="150px" align="center">
          <template slot-scope="scope">
            <a size="mini" style="color:#1fb2e5;cursor:pointer;" @click="handleEdit(scope.$index, scope.row)"
              v-if="scope.row.total_score >= 0">查看
            </a>
            <a size="mini" style="color:#C0C4CC;cursor:pointer;" v-else>查看
            </a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top:110px">
      <div class="bottomtion111" v-show="Hidethe_paging">
        <el-pagination background @current-change="pageCurrentChange" :pager-count="pageform.countPage"
          :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next"
          :total="pageform.total" :page-size='8'>
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import VePie from 'v-charts/lib/pie.common'
import { categoryTree } from '../../restful/api'

export default {
  inject: ['reload'],
  components: { VePie },
  name: 'Practices',

  data () {
    this.chartSettings = {
      radius: 50,
      offsetY: 100,
      label: {
        show: false,
      },
    }
    return {
      sum1: '',
      sum2: '',
      sum3: '',
      cateTree: [],
      classData: [],
      categoryTwoList: [],
      gradeData: [],
      classSort: 0,
      gradeSort: 0,
      userInfo: {},
      Hidethe_paging: true,
      dialogTableVisible: false,
      dialogTableVisible2: false,
      chartData1: [],
      chartData2: [],
      category_id: '',
      somee: '',
      chartData3: [],
      chartData11: [],
      params3: {
        type: 'score',
        user_id: this.$store.getters.getUserInfo.id,
      },
      loading: true,
      chartData22: [],
      chartData33: [],
      // 分页插件
      pageform: {
        total: null,
        pages: 1, // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 8, // 每页显示条目个数
        countPage: 11,
      },
      tableData: [],
      practiceList: [],
      // progress_width:80,
      categoryList: [],
      allTime: 0,
      value: '',
      count: '',
      count1: '',
      count2: 1,
      count3: 3,
      of_hidden: false,
      com_plete: true,
      sum: '',
      value2: '',

      loading: true,
      disabled: true,
      params2: {
        // class_id: this.$store.getters.getUserInfo.class_id,
        page_size: 8,
        page: 1,
        user_id: this.$store.getters.getUserInfo.id,
        category_id: '',
      },
    }
  },

  methods: {
    reset () {
      // this.getCategoryTree()
      // this.categoryTwoList = []
      // this.count =''
      // this.count2 = 1
      // this.pageform.pageNum = 1
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex === 0) {
        return 'warning-row'
      } else if (rowIndex === 1) {
        return 'success-row'
      } else if (rowIndex === 2) {
        return 'warning-row'
      } else if (rowIndex === 3) {
        return 'success-row'
      } else if (rowIndex === 4) {
        return 'warning-row'
      } else if (rowIndex === 5) {
        return 'success-row'
      } else if (rowIndex === 6) {
        return 'warning-row'
      } else if (rowIndex === 7) {
        return 'success-row'
      } else if (rowIndex === 8) {
        return 'warning-row'
      } else if (rowIndex === 9) {
        return 'success-row'
      }
      return ''
    },
    formatter (row) {
      return this.formatSeconds(row.total_time)
    },
    /* 分页插件 */
    // pageNum (当前页数)改变时会触发
    pageCurrentChange (val, e, form, jobExpLabel, pageform, searchVal) {
      console.log(val)
      this.pageform.pageNum = val
      // console.log(this.pageform.pageNum)
      this.params2.page = val
      this.getScore()
    },
    onPracticeChange (learn_id) {
      this.params2.learn_id = learn_id
      this.params2.page = 1
      this.pageform.pageNum = 1
      this.getScore()
    },
    //获取分类树
    getCategoryTree () {
      this.$http.categoryTree(this.params3).then((res) => {
        this.cateTree = res.data
      })
    },
    getUser () {
      if (this.$cookies.get('token')) {
        this.$http.getUserInfo().then((res) => {
          this.userInfo = res.data
          // console.log(this.userInfo)
          if (res.data.head_img) {
            if (res.data.head_img.indexOf('http') !== -1) {
              this.userInfo.head_img = res.data.head_img
            } else {
              this.userInfo.head_img = this.GLOBAL.BASE_URL + res.data.head_img
            }
          } else {
            this.userInfo.head_img = ''
          }

          this.$store.commit('SetUserInfo', res.data)
          //   console.log(this.userInfo)
        })
      }
    },

    // 获取分类列表
    getCategoryList () {
      this.practiceList = []
      this.$http
        .categoryList()
        .then((res) => {
          if (res.code !== 0) {
            this.categoryList = res.data
            //  console.log( this.categoryList)
          } else {
            this.$message.error(res.message)
          }
        })
        .catch((err) => {
          // console.log(err);
        })
    },
    handleEdit (index, row) {
      this.$router.push({
        name: 'practiceDetail',
        query: {
          id: row.id,
        },
      })
    },

    getScore () {
      this.$http.getScore(this.params2).then((res) => {
        if (res.code !== 0) {
          this.tableData = res.data.score
          console.log(res.data)
          this.loading = false
          this.pageform.pages = res.data.allPage
          console.log(this.pageform.pages)
          this.pageform.total = res.data.times
          // console.log(this.pageform.pages)
          // console.log(this.pageform.pages)
          if (this.pageform.pages == '1' || this.pageform.pages == '0') {
            this.Hidethe_paging = false
          } else {
            this.Hidethe_paging = true
          }
          this.allTime = res.data.allTime
          this.chartData1 = res.data.dabiao.height
          this.chartData2 = res.data.dabiao.middle
          this.chartData3 = res.data.dabiao.low
          this.sum1 = res.data.class.sort
          this.sum2 = res.data.grade.sort
          this.sum3 = res.data.grade.max_score
          this.sum = this.chartData1 + this.chartData2 + this.chartData3
          this.chartData11 = ((this.chartData1 / this.sum) * 100).toFixed(2)
          this.chartData22 = ((this.chartData2 / this.sum) * 100).toFixed(2)
          this.chartData33 = ((this.chartData3 / this.sum) * 100).toFixed(2)
          if (this.chartData11 == 'NaN') {
            this.chartData11 = 0
          }
          if (this.chartData22 == 'NaN') {
            this.chartData22 = 0
          }
          if (this.chartData33 == 'NaN') {
            this.chartData33 = 0
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },
    onChangeHandle (item, index) {
      // console.log(item)
      let category_id = item.value
      this.disabled = false
      this.params2.page = 1
      this.pageform.pageNum = 1
      this.params2.category_id = category_id
      this.getCourseList(category_id)
      let arr = this.cateTree.find((v) => v.value === item.value)
      // console.log(arr);
      this.count = index
      this.count2 = ''
      this.count1 = ''
      this.count3 = 3
      this.categoryTwoList = arr.children
      this.getScore()
    },
    training_type (item, index) {
      let category_id = item.value
      this.disabled = false
      this.params2.page = 1
      this.pageform.pageNum = 1
      this.params2.category_id = category_id
      this.count1 = index
      this.count3 = ''
      this.getCourseList(category_id)
      this.getScore()
    },
    color: function (index) {
      if (this.count === index) {
        return 'activee'
      }
    },
    clearHandle () {
      delete this.params2.learn_id
    },
    complete () {
      this.count3 = 3
      this.count1 = ''
      // console.log(this.count)
      this.tableData = []
      this.pageform.pageNum = 1
      this.show = true
      //  console.log( this.params.category_id)
      if (this.count == 0) {
        this.params2.category_id = 2
      } else {
        this.params2.category_id = 17
      }
      this.params2 = {
        page_size: 8,
        page: 1,
        category_id: this.params2.category_id,
      }
      this.getScore()
    },
    ofHidden () {
      this.count2 = 1
      this.count1 = ''
      this.count = ''
      this.cateTree = []
      this.categoryTwoList = []
      this.pageform.pageNum = 1
      this.params2 = {
        page_size: 8,
        page: 1,
      }
      this.getCategoryTree()
      this.getScore()
    },
    completeclor: function (index) {
      if (this.count2 === index) {
        return 'adad'
      }
    },
    completeclor1: function (index) {
      if (this.count3 === index) {
        return 'adadss'
      }
    },
    color: function (index) {
      if (this.count === index) {
        return 'activee'
      }
    },
    color2: function (index) {
      if (this.count1 === index) {
        return 'activ'
      }
    },
    // 获取训练列表
    getCourseList (category_id) {
      this.practiceList = []
      this.params2.category_id = category_id
      this.$http.courseAllList({ category_id: category_id }).then((res) => {
        if (res.code !== 0) {
          this.practiceList = res.data.learn
        } else {
          this.$message.error(res.message)
        }
      })
    },
    formatterLearn (row, column) {
      let arr = this.practiceList
      let newarr = arr.find(function (item) {
        return row.learn_id == item.id
      })
      return newarr.name
    },
    filterHandler (value, row, column) {
      const property = column['property']
      return row[property] === value
    },
  },
  mounted () {
    this.getCategoryList()
    this.getCategoryTree()
    this.getScore()
    this.getCourseList()
    this.getUser()
  },
  created () { },
}
</script>

<style lang="less">
@import '../../../static/fonts/stylemain/style.less';

/deep/ .el-table th.el-table__cell.is-leaf {
  background-color: @hed;
  color: @writing
}

.el-table__empty-block {
  background-color: @bg2;
}

@media screen and (max-width: 768px) {
  .bossbox {
    width: 100%;
    height: 100%;
    background-color: #212229;
    overflow: hidden;

    .activee {
      background: #009ad3;
      padding: 10px 10px 10px 10px;
      border-radius: 35px;
    }

    .activ {
      background: #009ad3;
    }

    .adad {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .adadss {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .schedule {
      width: 100%;
      height: 100rem;
      background-color: #212229;
      margin: auto;
      position: relative;

      img {
        position: absolute;
        top: 8rem;
        left: 7rem;
      }

      .pandect {
        width: 234px;
        height: 82px;
        position: absolute;
        top: 8rem;
        left: 45rem;

        .spa1 {
          position: absolute;
          top: 0;
          left: 0;
          color: #fff;
          font-size: 24px;
        }

        .spa2 {
          position: absolute;
          top: 14px;
          left: 105px;
          color: #909399;
          font-size: 14px;
        }

        .spa3 {
          position: absolute;
          top: 34px;
          left: 0;
        }

        .spa4 {
          position: absolute;
          top: 40px;
          left: 0;
          color: #c0c4cc;
          font-size: 14px;
        }

        .spa5 {
          position: absolute;
          top: 59px;
          left: 0;
          color: #c0c4cc;
          font-size: 14px;
        }

        .spa6 {
          position: absolute;
          top: 79px;
          left: 0;
          color: #c0c4cc;
          font-size: 14px;
        }

        .spa7 {
          position: absolute;
          top: 99px;
          left: 0;
          color: #c0c4cc;
          font-size: 14px;
        }

        .spa8 {
          position: absolute;
          top: 119px;
          left: 0;
          color: #c0c4cc;
          font-size: 14px;
        }
      }

      .statistics {
        width: 454px;
        height: 110px;
        position: absolute;
        top: 38rem;
        left: 7rem;

        .progress_out {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 10px;
          left: 0;
          margin-right: 10px;

          .progress_in {
            display: inline-block;
            height: 5px;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #245556, #24ab95, #06f0c9);
            // background: rgba(24, 201, 176, 0.8);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;

            img {
              position: absolute;
              top: -14px;
            }
          }
        }

        .progress_out1 {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 20px;
          left: 0;
          margin-right: 10px;

          .progress_in1 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #2e5a6a, #3b8eae, #44b3f0);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
          }
        }

        .progress_out2 {
          display: inline-block;
          width: 100%;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(56, 41, 47, 0.7);
          position: relative;
          top: 30px;
          left: 0;
          margin-right: 10px;

          .progress_in2 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #643338, #a9393c, #ff3131);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
            // left: 0;
          }
        }

        .percent {
          position: absolute;
          top: 15px;
          left: 220px;
          width: 50px;
          height: 70px;

          p {
            padding-top: 5px;
            font-size: 16px;
            color: #fff;
          }
        }

        .number_of {
          position: absolute;
          top: 34rem;
          left: 0rem;
          width: 150px;
          height: 70px;

          .p1 {
            position: absolute;
            top: 0;
            left: 0;
          }

          .p2 {
            position: absolute;
            top: 25px;
            left: 0;
          }

          .p3 {
            position: absolute;
            top: 52px;
            left: 0;
          }

          .number1 {
            position: absolute;
            left: 30px;
            top: 0;
            color: #fff;
          }

          .number2 {
            position: absolute;
            left: 30px;
            top: 26px;
            color: #fff;
          }

          .number3 {
            position: absolute;
            left: 30px;
            top: 52px;
            color: #fff;
          }
        }
      }
    }

    .options {
      width: 100%;
      // height: 270px;
      background-color: #191a1f;
      overflow: hidden;

      .type {
        width: 100%;
        height: 30rem;
        background-color: #111217;
        margin: 20px auto 0;
        position: relative;
      }

      .direction1 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem1 {
        line-height: 45rem;
        float: left;
        margin-left: 5rem;
        font-size: 14px;
        color: #fff;

        span {
          margin-left: 16px;
          margin-top: 15px;
        }
      }

      .directionitem2 {
        font-size: 14px;
        color: #fff;
        width: 85%;
        height: 100%;
        margin: 20rem auto 0;
        overflow: hidden;

        span {
          line-height: 10rem;
          display: flex;
          justify-content: space-around;
          height: 35px;
          padding: 2.6rem;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 100%;
        max-height: 320rem;
        background-color: #111217;
        margin: 20px auto;
        position: relative;
        overflow: hidden;

        .typebox-bor {
          width: 1210px;
          height: 2px;
          background-color: @bg2;
          position: absolute;
          top: 65px;
          left: 0;
        }
      }
    }

    .tablelist {
      width: 92%;
      height: 240rem;
      margin: auto;
      overflow: hidden;
      display: none;

      .el-table .warning-row {
        background: #24252c;
        color: rgb(203, 200, 200);
      }

      .el-table .success-row {
        background: #2a2b32;
        color: rgb(203, 200, 200);
      }
    }

    .tablelistt {
      width: 92%;
      height: 100%;
      margin: auto;
      overflow: hidden;

      .el-table .warning-row {
        background: #24252c;
        color: rgb(203, 200, 200);
      }

      .el-table .success-row {
        background: #2a2b32;
        color: rgb(203, 200, 200);
      }
    }

    .bottomtion111 {
      height: 65px;
      width: 100%;
      background-color: #2f3037;
      //  margin-top: 20px;
      position: absolute;
      bottom: 0;
      // z-index: 1000;
      display: flex;
      justify-content: center;
    }

    .el-pagination {
      margin: auto;
    }
  }
}

@media screen and (min-width: 768px) {
  .bossbox {
    width: 100%;
    min-height: 100vh;
    height: 100%;
    background-color: @bg3;
    overflow: hidden;

    .activee {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .activ {
      background: #009ad3;
    }

    .adad {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .adadss {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .schedule {
      width: 1216px;
      height: 221px;
      background-color: @bg3;
      margin: auto;
      position: relative;

      img {
        position: absolute;
        top: 77px;
        left: 197px;
      }

      .pandect {
        width: 234px;
        height: 82px;
        position: absolute;
        top: 75px;
        left: 286px;

        .spa1 {
          position: absolute;
          top: 0;
          left: 0;
          color: @writing;
          font-size: 24px;
        }

        .spa2 {
          position: absolute;
          top: 14px;
          left: 105px;
          color: @writing1;
          font-size: 14px;
        }

        .spa3 {
          position: absolute;
          top: 34px;
          left: 0;
        }

        .spa4 {
          position: absolute;
          top: 40px;
          left: 0;
          color: @writing1;
          font-size: 14px;
        }

        .spa5 {
          position: absolute;
          top: 59px;
          left: 0;
          color: @writing1;
          font-size: 14px;
        }

        .spa6 {
          position: absolute;
          top: 79px;
          left: 0;
          color: @writing1;
          font-size: 14px;
        }

        .spa7 {
          position: absolute;
          top: 99px;
          left: 0;
          color: @writing1;
          font-size: 14px;
        }

        .spa8 {
          position: absolute;
          top: 119px;
          left: 0;
          color: @writing1;
          font-size: 14px;
        }
      }

      .statistics {
        width: 454px;
        height: 110px;
        position: absolute;
        top: 65px;
        left: 570px;

        .progress_out {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 10px;
          left: 0;
          margin-right: 10px;

          .progress_in {
            display: inline-block;
            height: 5px;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #245556, #24ab95, #06f0c9);
            // background: rgba(24, 201, 176, 0.8);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;

            img {
              position: absolute;
              top: -14px;
            }
          }
        }

        .progress_out1 {
          display: inline-block;
          width: 200px;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(30, 57, 58, 0.7);
          position: relative;
          top: 20px;
          left: 0;
          margin-right: 10px;

          .progress_in1 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #2e5a6a, #3b8eae, #44b3f0);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
          }
        }

        .progress_out2 {
          display: inline-block;
          width: 100%;
          height: 5px;
          border-radius: 2px;
          background-color: rgba(56, 41, 47, 0.7);
          position: relative;
          top: 30px;
          left: 0;
          margin-right: 10px;

          .progress_in2 {
            display: inline-block;
            height: 5px;
            max-width: 100%;
            border-radius: 2px;
            //  background: pink; /* 针对不支持渐变的浏览器 */
            background: linear-gradient(to right, #643338, #a9393c, #ff3131);
            background-position: center right;
            position: absolute;
            top: 0;
            left: 0;
          }

          img {
            position: absolute;
            top: -14px;
            // padding-left: 15px;
            // left: 0;
          }
        }

        .percent {
          position: absolute;
          top: 15px;
          left: 220px;
          width: 50px;
          height: 70px;

          p {
            padding-top: 5px;
            font-size: 16px;
            color: @writing;
          }
        }

        .number_of {
          position: absolute;
          top: 16px;
          left: 295px;
          width: 150px;
          height: 70px;

          .p1 {
            position: absolute;
            top: 0;
            left: 0;
          }

          .p2 {
            position: absolute;
            top: 25px;
            left: 0;
          }

          .p3 {
            position: absolute;
            top: 52px;
            left: 0;
          }

          .number1 {
            position: absolute;
            left: 30px;
            top: 0;
            color: @writing;
          }

          .number2 {
            position: absolute;
            left: 30px;
            top: 26px;
            color: @writing;
          }

          .number3 {
            position: absolute;
            left: 30px;
            top: 52px;
            color: @writing;
          }
        }
      }
    }

    .options {
      width: 100%;
      //  height: 270px;
      background-color: @bg2;
      overflow: hidden;

      .type {
        width: 1216px;
        height: 68px;
        background-color: @bg1;
        margin: 35px auto 0;
        position: relative;
      }

      .direction1 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: @writing;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: @writing;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem1 {
        line-height: 35px;
        margin-left: 184px;
        font-size: 14px;
        color: @writing;

        span {
          margin-left: 16px;
          float: left;
          margin-top: 15px;
        }
      }

      .directionitem2 {
        margin-left: 160px;
        font-size: 14px;
        color: @writing;
        width: 891px;
        //  height: 127px;
        overflow: hidden;

        span {
          margin-top: 15px;
          margin-bottom: 17px;
          margin-left: 39px;
          float: left;
          height: 35px;
          line-height: 35px;
          padding: 0 10px 0 10px;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 1216px;
        max-height: 130px;
        background-color: @bg1;
        margin: 0px auto 22px;
        position: relative;
        overflow: hidden;

        .typebox-bor {
          width: 1210px;
          height: 2px;
          background-color: @bg2;
          position: absolute;
          top: 65px;
          left: 0;
        }

        .typeitem1 {
          width: 1116px;
          height: 67px;
          border-bottom: 2px solid @bg1;
        }

        .typeitem2 {
          width: 1216px;
          height: 67px;
        }
      }
    }

    .tablelist {
      width: 1216px;

      margin: auto;

      .el-table .warning-row {
        background: @bg1;
        color: @writing1;
      }

      .el-table .success-row {
        background: @bg2;
        color: @writing1;
      }
    }

    .tablelistt {
      width: 92%;

      margin: auto;
      display: none;
      overflow: hidden;

      .el-table .warning-row {
        background: @bg1;
        color: @writing1;
      }

      .el-table .success-row {
        background: @bg2;
        color: @writing1;
      }
    }

    .bottomtion111 {
      height: 65px;
      width: 100%;
      background-color: @bottomtion;
      //  margin-top: 20px;
      position: absolute;
      bottom: 0;
      // z-index: 1000;
      display: flex;
      justify-content: center;
    }

    .el-pagination {
      margin: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/User/Practices.vue